import styled from 'styled-components';

export const StatusButton = styled.button.attrs({
  type: 'button',
  className:
    'flex size-8 shrink-0 cursor-pointer items-center justify-center rounded-md transition-colors hover:bg-muted/80 disabled:cursor-default disabled:hover:bg-transparent',
})``;

export const StatusIcon = styled.img.attrs({
  className: 'size-8',
})``;
